import { useSignals } from '@preact/signals-react/runtime'
import clx from 'classnames'
import * as $ from '../../signal/searchbox'
import { CaretDownIcon, CaretUpIcon, EscIcon, SelectIcon } from '../Icons/Icons'
import styles from './Footer.module.css'

export function Footer() {
  useSignals()
  const oramaURL = new URL('https://askorama.ai')
  const referrer = window.location.hostname

  if (!['localhost', '127.0.0.1'].includes(referrer)) {
    oramaURL.searchParams.set('utm_source', referrer)
  }

  return (
    <>
      <footer
        className={clx(styles.footer, {
          [styles.footer__noKeyboardNavigationHints]: $.isSummaryExpanded.value || !$.isSummaryClamped.value
        })}
      >
        {$.keyboardNavigationHints.value && (
          <div data-testid="keyboardNavigationHints" className={styles.footer__keyboardList}>
            <ul className={styles.footer__keyboardList}>
              {!$.isSummaryExpanded.value && (
                <>
                  <li className={styles.footer__keyboardCommand}>
                    <kbd className={styles.footer__commandKey}>
                      <SelectIcon />
                    </kbd>
                    <span>to select</span>
                  </li>
                  <li className={styles.footer__keyboardCommand}>
                    <kbd className={styles.footer__commandKey}>
                      <CaretDownIcon />
                    </kbd>
                    <kbd className={styles.footer__commandKey}>
                      <CaretUpIcon />
                    </kbd>
                    <span>to navigate</span>
                  </li>
                </>
              )}
              <li className={styles.footer__keyboardCommand}>
                <kbd className={styles.footer__commandKey}>
                  <EscIcon />
                </kbd>
                <span>to close</span>
              </li>
            </ul>
          </div>
        )}
        <div className={styles.footer__logoContainer}>
          <span className={styles.footer__poweredBy}>Powered by </span>
          <a href={oramaURL.toString()} target="_blank" rel="noreferrer" aria-label="Orama">
            <img
              src={`https://website-assets.oramasearch.com/orama-when-${$.colorScheme.value}.svg`}
              alt="Powered by Orama"
              className={styles.footer__logo}
            />
          </a>
        </div>
      </footer>
    </>
  )
}
